import { Value } from "react-phone-number-input";

import { IPartner } from "./types";

export const partnerInitialState: IPartner = {
  address: {
    city: "",
    country: "",
    fullAddress: "",
    state: "",
    street: "",
    zipcode: ""
  },
  companyRegistrationNo: "",
  documents: [],
  email: "",
  isActive: false,
  partnerContact: {
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: {
      country: "",
      phone: "" as Value
    }
  },
  partnerId: "",
  partnerName: "",
  partnerType: "GARAGE",
  defleetCentreType: "",
  phoneNumber: {
    country: "",
    phone: "" as Value
  },
  id: "",
  VAT: "",
  timeZone: "",
  registeredAddress: {
    street: "",
    city: "",
    fullAddress: "",
    state: "",
    zipcode: "",
    country: ""
  },
  tradingAddress: {
    street: "",
    city: "",
    fullAddress: "",
    state: "",
    zipcode: "",
    country: ""
  },
  tradingAddressSame: false,
  billingContact: {
    phoneNumber: {
      phone: "" as Value,
      country: ""
    },
    email: ""
  }
};
